export default {
	code: {
		presence: { message: '^schemas.presence' },
	}
};
